export default __webpack_public_path__ + "static/media/oscer-pres-neck-stiffness.8ec39f1c.svg";